import { eduIDApi } from "./common";
export const eidasApi = eduIDApi.injectEndpoints({
    endpoints: (builder) => ({
        eidasVerifyIdentity: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "verify-identity",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "verifyIdentity" }),
                });
            },
            extraOptions: { service: "eidas" },
        }),
        eidasVerifyCredential: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "verify-credential",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "verifyCredential" }),
                });
            },
            extraOptions: { service: "eidas" },
        }),
        eidasMfaAuthenticate: builder.query({
            query: (body) => {
                var _a;
                return ({
                    url: "mfa-authenticate",
                    body: Object.assign(Object.assign({}, body), { frontend_action: (_a = body.frontend_action) !== null && _a !== void 0 ? _a : "loginMfaAuthn" }),
                });
            },
            extraOptions: { service: "eidas" },
        }),
        eidasGetStatus: builder.query({
            query: (body) => ({
                url: "get-status",
                body,
            }),
            extraOptions: { service: "eidas" },
        }),
        eidasMfaRegister: builder.query({
            query: () => ({
                url: "mfa-register",
                body: {
                    method: "eidas",
                    frontend_action: "signupExternalMfa",
                },
            }),
            extraOptions: { service: "eidas" },
        }),
        frejaMfaRegister: builder.query({
            query: () => ({
                url: "mfa-register",
                body: {
                    method: "freja",
                    frontend_action: "signupExternalMfa",
                },
            }),
            extraOptions: { service: "eidas" },
        }),
    }),
});
